module.exports = __webpack_public_path__ + "img/nabl_thumbnail.aa50da71.jpg";